import { DropResult } from 'react-beautiful-dnd';

export const useReorderItems = (
  reorderItems: (sourceIndex: number, destinationIndex: number) => void
) => {
  const onDragEnd = (result: DropResult) => {
    if (
      !result.destination ||
      result.source.index === result.destination.index
    ) {
      return;
    }

    reorderItems(result.source.index, result.destination.index);
  };

  return {
    onDragEnd,
  };
};
